import { render, staticRenderFns } from "./AboutPageOurProjects.vue?vue&type=template&id=4338f000&scoped=true"
import script from "./AboutPageOurProjects.vue?vue&type=script&lang=ts"
export * from "./AboutPageOurProjects.vue?vue&type=script&lang=ts"
import style0 from "./AboutPageOurProjects.vue?vue&type=style&index=0&id=4338f000&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4338f000",
  null
  
)

export default component.exports